export default "__VITE_ASSET__B3SWZyr5__"